module.exports = __webpack_public_path__ + "img/27.ab9ce09f.jpg";